enum ColorType {
  Base = 'base',
  Roof = 'roof',
  ColorPack = 'pack',
}

export default ColorType;
